import { render, staticRenderFns } from "./tablelist.vue?vue&type=template&id=b5e45f48&scoped=true&"
import script from "./tablelist.vue?vue&type=script&lang=js&"
export * from "./tablelist.vue?vue&type=script&lang=js&"
import style0 from "./tablelist.vue?vue&type=style&index=0&id=b5e45f48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e45f48",
  null
  
)

export default component.exports